import { documentationActions } from '../../actions/constant';

const {
  HOLD_DAILY_NOTE_FROM_BILLING_SUCCESS,
  HOLD_DAILY_NOTE_FROM_BILLING_FAILURE,
  HOLD_DAILY_NOTE_FROM_BILLING_LOADING,
  HOLD_DAILY_NOTE_FROM_BILLING_RESET,
} = documentationActions;

export const applyHeldFromBilling = (state: any, payload: any) => {
  const dailySessionNoteUuid = payload?.dailySessionNoteUuid;
  const content = state?.response?.content;
  if (!dailySessionNoteUuid || !Array.isArray(content)) return state;
  return {
    ...state,
    response: {
      ...state.response,
      content: content.map((document: any) =>
        document?.dailySessionNoteUuid === dailySessionNoteUuid
          // THIN-8050: a hold placed from this screen is a person's, so the origin follows the flag.
          ? { ...document, heldFromBilling: payload?.hold, holdOrigin: payload?.hold ? 'MANUAL' : null }
          : document
      ),
    },
  };
};

const initialstate: object = {
  response: null,
  loading: false,
  isSuccess: false,
  hold: null,
  dailySessionNoteUuid: null,
};

export const holdDailyNoteFromBillingReducer = (state = initialstate, action: any) => {
  switch (action.type) {
    case HOLD_DAILY_NOTE_FROM_BILLING_SUCCESS:
      return {
        ...state,
        response: action.payload?.response,
        hold: action.payload?.hold,
        dailySessionNoteUuid: action.payload?.dailySessionNoteUuid,
        loading: false,
        isSuccess: true,
      };

    case HOLD_DAILY_NOTE_FROM_BILLING_FAILURE:
      return {
        ...state,
        response: action.payload,
        loading: false,
        isSuccess: false,
      };

    case HOLD_DAILY_NOTE_FROM_BILLING_LOADING:
      return {
        ...state,
        loading: true,
      };

    case HOLD_DAILY_NOTE_FROM_BILLING_RESET:
      return initialstate;

    default:
      return state;
  }
};
